export default "/e891d4a0bdc60f2a6a9b4e97d7422547d2a79dc5/74cc88c7571ddfe8037db442e45677ad.svg";